import { render, staticRenderFns } from "./homepage-updated.vue?vue&type=template&id=e1903f52&"
import script from "./homepage-updated.vue?vue&type=script&lang=ts&"
export * from "./homepage-updated.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports